export default "__VITE_ASSET__CZ4q3OE4__"